module.exports = __webpack_public_path__ + "static/media/cover_dinner.d4d4431b.png";